/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { MandateAssignment } from './mandateAssignment';

/**
 * DEPRECATED: Use mandates instead.
Included for backward compatibility with legacy frontend.
 */
export type CourseModuleSettingsOutputResponsibilities = MandateAssignment | null;
